import { RootState } from '../types';
import { ManagerNote } from './managerNotes.types';

export const selectManagerNote =
  (locationId: ManagerNote['location_id'], date: ManagerNote['date']) => (state: RootState) =>
    state.reducer.managerNotes[locationId]?.[date];
